import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import bgLocale from '../public/locales/bg.json';
import daLocale from '../public/locales/da.json';
import deLocale from '../public/locales/de.json';
import enLocale from '../public/locales/en.json';
import esLocale from '../public/locales/es.json';
import etLocale from '../public/locales/et.json';
import fiLocale from '../public/locales/fi.json';
import frLocale from '../public/locales/fr.json';
import hrLocale from '../public/locales/hr.json';
import huLocale from '../public/locales/hu.json';
import itLocale from '../public/locales/it.json';
import ltLocale from '../public/locales/lt.json';
import lvLocale from '../public/locales/lv.json';
import nlLocale from '../public/locales/nl.json';
import plLocale from '../public/locales/pl.json';
import ptLocale from '../public/locales/pt.json';
import roLocale from '../public/locales/ro.json';
import svLocale from '../public/locales/sv.json';

const resources = {
  de: {
    translation: deLocale,
  },
  en: {
    translation: enLocale,
  },
  es: {
    translation: esLocale,
  },
  fr: {
    translation: frLocale,
  },
  nl: {
    translation: nlLocale,
  },
  it: {
    translation: itLocale,
  },
  pl: {
    translation: plLocale,
  },
  fi: {
    translation: fiLocale,
  },
  da: {
    translation: daLocale,
  },
  sv: {
    translation: svLocale,
  },
  pt: {
    translation: ptLocale,
  },
  ro: {
    translation: roLocale,
  },
  hu: {
    translation: huLocale,
  },
  bg: {
    translation: bgLocale,
  },
  et: {
    translation: etLocale,
  },
  hr: {
    translation: hrLocale,
  },
  lt: {
    translation: ltLocale,
  },
  lv: {
    translation: lvLocale,
  },
};

export const i18nErrorCallback = (err: any) => {
  if (err) console.log('something went wrong loading language', err);
};

i18next.use(LanguageDetector).init(
  {
    resources,
    fallbackLng: 'en',
    react: {
      useSuspense: false,
    },
    detection: {
      lookupCookie: 'i18nextLocale',
      caches: ['cookie'],
      cookieMinutes: 10 * 24 * 60 * 60,
    },
  },
  i18nErrorCallback,
);

export default i18next;
